import React from 'react'
import { ContentHeader } from '../../../../../layout/Content'

function ProductsWithExpirationsHeader() {
  return ( <ContentHeader title='Products With Expirations Inventory' /> )
}

export default React.memo(ProductsWithExpirationsHeader)
